import moment from 'moment';
import * as Sentry from '@sentry/browser';
import { takeEvery, select, getContext } from 'redux-saga/effects';
import i18n from 'i18next';
import selectState from '../utils/selectState';
import { actions, CHANGE_LANG } from '../actions/app';
import { AppConfig } from 'types/config';
import { version, currentUserId } from '../selectors/app';
import { cookieManager } from 'libs/cookie';
import { Services } from 'init/services';
import { SagaContext } from 'shared/types/common';

type LanguageAction = ReturnType<typeof actions.changeLanguage>;

export default function* appInitSaga({ sentry }: AppConfig) {
  const appVersion: ReturnType<typeof version> = yield selectState(version);
  const apolloClient: Services[SagaContext.ApolloClient] = yield getContext(
    SagaContext.ApolloClient
  );

  // tslint:disable-next-line no-console
  console.log(`Application run (version ${appVersion})`);

  if (sentry) {
    Sentry.init({
      dsn: sentry.DSN,
      release: appVersion,
      blacklistUrls: [/px[.]adhigh[.]net/],
    });

    const userId: ReturnType<typeof currentUserId> = yield select(currentUserId);
    if (userId) {
      Sentry.configureScope((scope) => scope.setUser({ id: `${userId}` }));
    }
  } else {
    process.env.NODE_ENV !== 'development' && console.error('Sentry does not configured');
  }

  yield takeEvery<LanguageAction>(CHANGE_LANG, ({ payload: { language } }) => {
    moment.locale(language);
    i18n.changeLanguage(language);

    document.cookie = 'locale=;expires=' + new Date(0);
    document.cookie = 'locale=;expires=' + new Date(0);

    cookieManager.set('locale', language, {
      expires: moment().add(2, 'y').toDate(),
    });
    apolloClient.resetStore();
  });
}
